import React from 'react'
import Modal from '@mui/material/Modal'
import Button from '../../Button/Button'
import cube_animated_deploy_token from '../../../../assets/images/cube_animated_deploy_token.gif'
import { cantPowerUpTokenModal as styles } from './cantPowerUpTokenModal.tailwind.js'


const CantPowerUpTokenModal = ({ isOpen, onClose }) => {

    const hours = process.env.REACT_APP_HOURS_BEFORE_DEPLOY_TOKEN
    const data = {
        image: cube_animated_deploy_token,
        heading: `Power Up Unavailable`,
        message: `Tokens can only be powered up within ${hours} hours before the game starts. Currently, this option is unavailable.`,
    };


    return (
        <Modal open={isOpen} onClose={() => { }} disableAutoFocus>
            <div className={styles.container}>
                <div className={styles.imageBackground}>
                    <div className={styles.imageContainer}>
                        <img src={data.image} alt="Reward" className={styles.image} />
                    </div>
                </div>

                <div className={styles.innerContainer}>
                    <div className={styles.heading}>{data.heading}</div>
                    <div className='mb-[8px]'>{data.message}</div>
                    <Button variant="primary" onClick={onClose} className='!uppercase'>Back To Home</Button>
                </div>
            </div>
        </Modal>
    );
};

export default CantPowerUpTokenModal;